export const getEdgeUrl = (path: string) =>
  `https://edge.reebelo.com/${path}`.replace('+', '%2B');
